import React, { useEffect, useState } from "react";
import { PageHeader, Alert, Space, Descriptions, Button } from "antd";

import Block from "./components/Block";
import Account from "./components/Account";
import { SpaceBetween } from "./styles";
import { useHistory, useParams } from "react-router-dom";
import { Container } from "../../globals/styles";
import { helpers, dateUtil } from "../../utils";
import { requests, getUrl } from "../../globals/requests";
import { updateUser, getUser } from "../../state/actions/userActions";
import { connect } from "react-redux";

function User(props) {
  const history = useHistory();
  const { user, getUser: getOneUser, updateUser: updateOneUser } = props;
  const { userId } = useParams();
  // const [user, setUser] = useState(history?.location?.state?.user);
  const [summary, setSummary] = useState([]);
  const [loadingRestricted, setLoadingRestricted] = useState(false);
  const [loadingCanWithdraw, setLoadingCanWithdraw] = useState(false);
  const [loadingDeleteAccount, setLoadingDeleteAccount] = useState(false);
  const [account, setAccount] = useState({});
  useEffect(() => {
    async function getUserSummary() {
      try {
        const url = `${getUrl("users")}/${userId}/summary`;
        const response = await requests.getWithAuth(url);
        setSummary(response.data);
      } catch (e) {
        helpers.displayMessage(e);
      }
    }

    getUserSummary();
  }, [userId]);

  useEffect(() => {
    async function getUserAccounts() {
      try {
        const url = `${getUrl("accounts")}`;
        const response = await requests.getWithAuth(url, { owner: userId });
        setAccount(response.data.filter((el) => el.type === "real")[0] || {});
      } catch (e) {
        helpers.displayMessage(e);
      }
    }

    getUserAccounts();
  }, [userId]);

  async function removeAccount(id) {
    try {
      const res = window.confirm(
        "Are you sure you want to delete this account?"
      );
      if (!res) return;

      const url = `${getUrl("accounts")}/${id}`;
      setLoadingDeleteAccount(true);
      await requests.deleteWithAuth(url);
      helpers.successModal({
        title: "Success",
        content: "Bank account removed",
      });
      setAccount({});
      setLoadingDeleteAccount(false);
    } catch (e) {
      helpers.displayMessage(e);
    }
  }

  useEffect(() => {
    async function getUser() {
      try {
        await getOneUser(userId);
      } catch (e) {
        helpers.displayMessage(e);
      }
    }

    getUser();
  }, [getOneUser, userId]);

  function userSavings() {
    history.push(`/dashboard/users/${userId}/savings`, { user });
  }
  function userInvestments() {
    history.push(`/dashboard/users/${userId}/investments`, { user });
  }
  function userusers() {
    history.push(`/dashboard/users/${userId}/users`, {
      user,
    });
  }

  async function toggleCanWithdraw() {
    try {
      setLoadingCanWithdraw(true);
      const url = `${getUrl("users")}/${user?._id}/canWithdraw`;
      await requests.putWithAuth(url, {
        canWithdraw: !user?.canWithdraw,
      });
      setLoadingCanWithdraw(false);
      updateOneUser(user?.id, { canWithdraw: !user?.canWithdraw });
    } catch (e) {
      helpers.displayMessage(e);
      setLoadingCanWithdraw(false);
    }
  }
  async function toggleRestricted() {
    try {
      setLoadingRestricted(true);
      const url = `${getUrl("users")}/${user?._id}/restricted`;
      await requests.putWithAuth(url, { restricted: !user?.restricted });
      updateOneUser(user?.id, { restricted: !user?.restricted });
      setLoadingRestricted(false);
    } catch (e) {
      setLoadingRestricted(false);
      helpers.displayMessage(e);
    }
  }

  return (
    <Container>
      <PageHeader
        className="site-page-header"
        onBack={() => history.goBack()}
        title="User"
        subTitle={`${user?.first_name + " " + user?.last_name}'s Menu`}
      />

      <Space style={{ width: "100%" }} direction="vertical" size="large">
        {(user?.restricted || !user?.canWithdraw) && (
          <Alert
            message="Suspicious activities has been noticed with this user."
            type="warning"
            showIcon
            closable
          />
        )}
        <Descriptions
          bordered
          title="User access control"
          size="default"
          extra={
            <Space>
              <Button loading={loadingRestricted} onClick={toggleRestricted}>
                {user?.restricted
                  ? "Unrestrict app accces"
                  : "Restrict app accces"}
              </Button>
              <Button loading={loadingCanWithdraw} onClick={toggleCanWithdraw}>
                {user?.canWithdraw
                  ? "Restrict withdrawal"
                  : "Unrestrict withdrawal"}
              </Button>
            </Space>
          }
        >
          <Descriptions.Item label="Name">
            {user?.first_name}&nbsp;{user?.last_name}
          </Descriptions.Item>
          <Descriptions.Item label="Email">{user?.email}</Descriptions.Item>
          <Descriptions.Item label="Phone No">
            {user?.phone_no}
          </Descriptions.Item>
          <Descriptions.Item label="Location">
            {user?.location}
          </Descriptions.Item>
          <Descriptions.Item label="Payment Attempted On">
            {dateUtil.formatDate(user?.created_at)}
          </Descriptions.Item>
        </Descriptions>
        <div>
          <p>
            <b>Users Account</b>
          </p>
          {account?._id ? (
            <Account
              loading={loadingDeleteAccount}
              ondeleteAccount={() => removeAccount(account?._id)}
              {...account}
            />
          ) : (
            <p>User doesn't have a withdrawal account.</p>
          )}
        </div>
        <SpaceBetween>
          <Block
            onClick={userSavings}
            value={user?.noOfSavings ?? 0}
            display="Savings"
          />

          <Block
            onClick={userInvestments}
            value={user?.noOfInvestments ?? 0}
            display="Investments"
          />
        </SpaceBetween>
        <SpaceBetween>
          <Block
            value={summary?.noOfLoanApplications}
            display="Loan Applications"
          />
          <Block
            onClick={userusers}
            value={summary?.noOfusers}
            display="users"
          />
        </SpaceBetween>
      </Space>
    </Container>
  );
}

const mapStateToProps = (state) => {
  return {
    user: state.userReducer.user,
  };
};

export default connect(mapStateToProps, { updateUser, getUser })(User);
